import "./sprinkles.css.ts.vanilla.js";
import "./responsive-layout.css.ts.vanilla.js";
var v = "_1y2v1nf7p", n = "_17lofg75 _1y2v1nf7p", a = "_1y2v1nf2r", e = "_17lofg73";
export { v as container, n as fullWidth, a as inverseBackground, e as responsiveLayout };
